import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataService} from '../data.service';
import { AuditTrail } from 'src/app/features/hhg-shipment-accessorials/audit-trail';

@Injectable({
  providedIn: 'root'
})
export class HhgShipmentAuditTrailService extends DataService {

  public observable$: any;

  constructor(http: HttpClient) {
    super(http);
    this.setUri(this.baseURI);
  }

  private baseURI = this.apiUri + '/auditTrail/';

  // Function to get the AuditTrail Log list by shipmentId
  getAuditTrailListByShipmentId(shipmentId: number): Observable<any> {
    const auditTrailListUrl = this.baseURI + shipmentId + '/shipmentId';
    this.setUri(auditTrailListUrl);
    return this.get();
  }

  saveMultipleAuditTrailRecords(auditTrailArray: AuditTrail[]): Observable<any> {
    return this.http
      .post(this.baseURI + 'saveMultipleAuditTrailRecords', auditTrailArray);
  }

}
